export default "__VITE_ASSET__Bl7Jijo8__"